import { createRouter, createWebHistory } from 'vue-router'
import { toast } from 'vue3-toastify';

import ENV from "../env.json";
import API from './utils/API';
import { meta } from '@turf/turf';

/** ------------------------ */

const error = [
  {
    component: () => import('@/errors/404.vue'),
    name: '404',
    path: '/:notFound',
  },
  {
    component: () => import('@/errors/API.vue'),
    name: 'Error_Api',
    path: '/ApiError',
  }
];

const application = [
  {
    component: () => import('@/app/popup/APP_POPUP.vue'),
    name: 'APP_POPUP',
    path: ENV.PATH_POPUP + ':dev_id(\\d+)/',
    meta:{
      // fullscreen: true,
    }
  },
  {
    component: () => import('@/app/popup/APP_POPUP.vue'),
    name: 'APP_POPUP_MILESTONE',
    path: ENV.PATH_POPUP + 'milestone/:dev_id(\\d+)/',
    meta: {
      // fullscreen: true,
    }
  },
];

/** ------------------------ */

const routerHistory = createWebHistory();
const router = createRouter({
  history: routerHistory,
  routes: [
    ...error,
    ...application
  ]
})

router.beforeResolve((to, from, next) => {
  if (to?.meta?.rights !== undefined) {
    if (
      $root.user.can(
        to.meta.rights.levels,
        to.meta.rights.name
      ) === false
    ) {
      toast.error(
        $root.$e("Vous n'avez pas les droits pour accéder à cette page"),
        $root.toastConfig
      );

      API.get("FRONT_ERROR", {
        error: "ACCESS_DENIED",
        url: to.fullPath
      });
      return false;
    }
  }

  next();
});

router.afterEach((to, from) => {
  let title = (to?.meta?.title !== undefined)
    ? ENV.SITE_TITLE + ' - ' + to.meta.title
    : ENV.SITE_TITLE;

  document.title = title;
})

export default router
